import { defineStore } from 'pinia';

export const useAppStore = defineStore('app', {
  state: () => ({
    isDarkTheme: false,
    locale: 'UA',
    sidebarOpen: true,
    error: null
  }),

  getters: {
    theme: (state) => state.isDarkTheme ? 'dark' : 'light',
    getLocale: (state) => state.locale,
    isSidebarOpen: (state) => state.sidebarOpen,
    getError: (state) => state.error
  },

  actions: {
    toggleTheme() {
      this.isDarkTheme = !this.isDarkTheme;
    },

    setTheme(isDark) {
      this.isDarkTheme = isDark;
    },

    setLocale(locale) {
      this.locale = locale;
    },

    toggleSidebar() {
      this.sidebarOpen = !this.sidebarOpen;
    },

    setSidebarOpen(open) {
      this.sidebarOpen = open;
    },

    setError(error) {
      this.error = error;
    },

    clearError() {
      this.error = null;
    }
  },

  persist: true
});
